import { Box } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';

export const MemberListWrapper = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: 0,
  transition: 'opacity .5s',
  top: '40px',
  zIndex: 999,
}));

export const MemberListWrapperMobile = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: theme.spacing(1),
  transition: 'opacity .5s',
  top: '290px',
  zIndex: 999,
}));

export const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(.75);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

export const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

interface AnimatedItemProp {
  opacity: number;
}

export const AnimatedItem = styled('div')<AnimatedItemProp>(
  ({ theme, opacity }) => ({
    display: 'flex',
    alignItems: 'center',
    animation: `${fadeIn} 0.15s `,
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    boxShadow:
      '0px 3px 5px -1px rgba(0, 0, 0, 0.20), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)',
    background: 'rgba(44, 44, 53, 0.60)',
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(1),
    opacity: opacity,
    transition: 'opacity .5s',
    '& p': {
      fontSize: '12px',
    },
  }),
);

export const FadeOutItem = styled('div')(({ theme }) => ({
  animation: `${fadeOut} 5s `,
}));
